import SpecialOffer from './SpecialOffer';

export default SpecialOffer;
